function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.1 3.9C15.63-.57 8.36-.57 3.89 3.9c-4.47 4.47-4.47 11.74 0 16.21A11.44 11.44 0 0012 23.46c2.94 0 5.87-1.12 8.11-3.35 4.46-4.47 4.46-11.74-.01-16.21zm-.84 15.36c-4 4-10.51 4-14.51 0s-4-10.51 0-14.51c2-2 4.63-3 7.26-3s5.26 1 7.26 3c3.99 4 3.99 10.51-.01 14.51z",
  fill: "#7F63FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.09 11.4H12.6V6.91c0-.33-.27-.6-.6-.6-.33 0-.6.27-.6.6v4.49H6.91c-.33 0-.6.27-.6.6 0 .33.27.6.6.6h4.49v4.49c0 .33.27.6.6.6.33 0 .6-.27.6-.6V12.6h4.49c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6z",
  fill: "#7F63FF"
});

function SvgAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "d97c8ba34c6591699c38b58a16db34a1.svg";
export { SvgAttach as ReactComponent };